import { useQuery } from '@tanstack/react-query';
import { fetchLevelsOptions } from '../../api/generated/@tanstack/react-query.gen';

// Re-export generated type for backwards compatibility
export type { Level } from '../../api/generated/types.gen';

export function useLevelsQuery() {
  const query = useQuery(fetchLevelsOptions());
  // Return levels array for backwards compatibility
  return {
    ...query,
    data: query.data?.levels,
  };
}
